import request from '@/services/request';

export const upsert = data => request.post('/design', data);

export const get = id => request.get(`/design/${id}`);

export const getToEdit = () => request.get('/design/editor');
